export default __webpack_public_path__ + "2f7fbbd7d8eee807e437e660436c6033.woff";